import React from 'react';
import { Box, Typography } from '@mui/material';

export const PromptSyntaxContent: React.FC = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Parameter Replacement
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 1 }}>
        {'{{param-name}}'}
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
        <li>Replaces with parameter value</li>
        <li>Empty string if parameter not provided</li>
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
        Tag-Based Conditionals
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 1 }}>
        {'{{if #tag}}...{{else}}...{{endif}}'}
        <br />
        {'{{if #tag1 and #tag2}}...{{endif}}'}
        <br />
        {'{{if #tag1 or #tag2}}...{{endif}}'}
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
        <li>Tags are case-insensitive and trimmed</li>
        <li>Only &apos;and&apos; OR &apos;or&apos; operators (no mixing)</li>
        <li>{'{{else}}'} block is optional</li>
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
        Probability-Based Conditionals
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 1 }}>
        {'{{prob 0.5}}...{{else}}...{{endprob}}'}
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
        <li>Probability range: (0, 1]</li>
        <li>Each block draws independently</li>
        <li>{'{{else}}'} block is optional</li>
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
        Nested Blocks
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 1 }}>
        {'{{if #tag1}}'}
        <br />
        {'  {{prob 0.5}}Option A{{else}}Option B{{endprob}}'}
        <br />
        {'{{else}}'}
        <br />
        {'  Default'}
        <br />
        {'{{endif}}'}
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
        <li>Blocks can be nested</li>
        <li>Each {'{{else}}'} binds to its matching opening block</li>
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
        Fenced Code Blocks
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 1 }}>
        ```json
        <br />
        {`{"example": "value"}`}
        <br />
        ```
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
        <li>Surrounded by triple backticks (```)</li>
        <li>Preserved as literal text</li>
        <li>Directives inside are not parsed</li>
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
        Important Notes
      </Typography>
      <Typography variant="body2" component="ul" sx={{ mt: 0, pl: 3 }}>
        <li>
          JSON objects like {`{"key": "value"}`} are treated as literal text
        </li>
        <li>All blocks must be properly closed with matching end tags</li>
        <li>Probability values must be greater than 0 and up to 1</li>
      </Typography>
    </Box>
  );
};
